import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/shadcn/accordion'
import { useMemo } from 'react'
import { GroupedTemplatesData } from './types'
import { TemplateItem } from './TemplateItem'
import { TemplateGroup } from './TemplateGroup'

export function TemplatesAccordion({ summary }: { summary: GroupedTemplatesData }) {
  const { items } = summary
  const groupNames = useMemo(() => items.map((item) => item.groupName), [items])
  return (
    <Accordion type="multiple" className="w-full overflow-hidden rounded-lg" defaultValue={groupNames}>
      {items.map((groupItem) => {
        return (
          <AccordionItem key={groupItem.groupName} value={groupItem.groupName} className="gap-2">
            {/* <AccordionTrigger className="first: bg-offwhite px-5 text-lg text-primary"> */}
            <AccordionTrigger className="first: bg-offwhite px-5 text-lg">{groupItem.groupName}</AccordionTrigger>
            <AccordionContent className="border-l p-5 pr-0">
              {groupItem.items.map((parentItem) => (
                <TemplateGroup key={parentItem.name} name={parentItem.name}>
                  {parentItem.items.map((childItem) => (
                    <TemplateItem
                      groupName={groupItem.groupName}
                      parentName={parentItem.name}
                      key={childItem.file_template.id}
                      item={childItem}
                    />
                  ))}
                </TemplateGroup>
              ))}
            </AccordionContent>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
